import { ContentNodeType } from "../../editor-config-context";
import { ContentNodeDefinition } from "../types";

const DatasetExamplesDefinition: ContentNodeDefinition = {
  nodeType: ContentNodeType.DatasetExamples,
  regex: /«««(.+?)»»»/g,
  toXML: content => {
    const match = content[1];
    const parts = match.split(":");

    if (parts.length < 6 || parts[0] !== "dataset") {
      // Invalid format, return empty dataset examples node
      return '<dataset-examples mounted="true"></dataset-examples>';
    }

    const [, dataset, version, examples, columns, dataType] = parts;
    let props = 'mounted="true"';

    if (dataset) {
      props += ` dataset="${dataset}"`;
    }
    if (version) {
      props += ` version="${version}"`;
    }
    if (examples) {
      props += ` examples="${examples}"`;
    }
    if (columns) {
      props += ` columns="${columns}"`;
    }
    if (dataType) {
      props += ` dataType="${dataType}"`;
    }

    return `<dataset-examples ${props}></dataset-examples>`;
  },
};

export default DatasetExamplesDefinition;
